import { createContext, useContext } from 'react';
import type { MapEdgeAnchor, MapEdgeWaypoint, MapNodeRow } from '../../lib/systemMap';

export type MapEdgeEndpoint = 'source' | 'target';

export type SystemMapEdgeActions = {
  onWaypointsChange: (edgeId: string, waypoints: MapEdgeWaypoint[]) => void;
  onWaypointsCommit: (edgeId: string, waypoints: MapEdgeWaypoint[]) => void;
  selectedWaypointIndex: number | null;
  onSelectWaypoint: (edgeId: string, index: number | null) => void;
  onAnchorChange: (edgeId: string, endpoint: MapEdgeEndpoint, anchor: MapEdgeAnchor) => void;
  onAnchorCommit: (edgeId: string, endpoint: MapEdgeEndpoint, anchor: MapEdgeAnchor) => void;
  selectedEndpoint: MapEdgeEndpoint | null;
  onSelectEndpoint: (edgeId: string, endpoint: MapEdgeEndpoint | null) => void;
  getNodeRow: (nodeId: string) => MapNodeRow | undefined;
};

const SystemMapEdgeActionsContext = createContext<SystemMapEdgeActions | null>(null);

export function SystemMapEdgeActionsProvider({
  value,
  children,
}: {
  value: SystemMapEdgeActions;
  children: React.ReactNode;
}) {
  return (
    <SystemMapEdgeActionsContext.Provider value={value}>{children}</SystemMapEdgeActionsContext.Provider>
  );
}

export function useSystemMapEdgeActions(): SystemMapEdgeActions {
  const ctx = useContext(SystemMapEdgeActionsContext);
  if (!ctx) {
    throw new Error('useSystemMapEdgeActions must be used within SystemMapEdgeActionsProvider');
  }
  return ctx;
}
